import { useTranslation } from 'react-i18next';
import { TranslationNS } from '@gokrew/models/constants';
import { GoalStatus } from '@gokrew/models/performance';
import { cn } from '@/lib/utils';
import { formatPercent } from '@/utility/percent';
import styles from './Goals.module.css';

const BAR_CLASS: Record<GoalStatus, string> = {
  [GoalStatus.ON_TRACK]: styles.barOnTrack,
  [GoalStatus.AT_RISK]: styles.barAtRisk,
  [GoalStatus.OFF_TRACK]: styles.barOffTrack,
};

export interface GoalProgressProps {
  /** 0 to 100. */
  progress: number;
  status: GoalStatus;
  className?: string;
}

/** A goal's progress bar, coloured by its status, with the percentage. */
export const GoalProgress = ({
  progress,
  status,
  className,
}: GoalProgressProps) => {
  const { t } = useTranslation(TranslationNS.Performance);
  const value = Math.max(0, Math.min(100, Math.round(progress)));
  return (
    <div className={cn(styles.progress, className)}>
      <div
        className={styles.track}
        role="progressbar"
        aria-valuemin={0}
        aria-valuemax={100}
        aria-valuenow={value}
        aria-label={t('shared.goal.progressLabel', { value })}
      >
        <span
          className={cn(styles.bar, BAR_CLASS[status])}
          style={{ width: `${value}%` }}
        />
      </div>
      <span className={styles.percent}>{formatPercent(value)}</span>
    </div>
  );
};
